<template>
  <swiper 
    :loop="true"
    :modules="modules" 
    :auto-height="false"
    :pagination="{ clickable: true }"
    class="avisosSwiper">
      <swiper-slide :key="slide" v-for="slide in slides">
        <div class="grid-container">
          <div class="grid-item" v-for="item in slide">
            <router-link :to="{path: `/avisosecomunicados/${item.post_name}`}" 
                class="tipo">
                  <i class="ms-Icon ms-Icon--TextDocument"
                      title="TextDocument"
                      aria-hidden="true"></i>
                  <span class="assunto">{{item.post_title}}</span>
              </router-link>
              <router-link :to="{path: `/avisosecomunicados/${item.post_name}`}" 
                class="title">
                  {{item.docaviso_descricao}}
              </router-link>
          </div>
        </div>
      </swiper-slide>
  </swiper>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue';

import 'swiper/css';
import 'swiper/css/pagination';

import { Pagination } from 'swiper/modules';

export default {
  components:{
    Swiper,
    SwiperSlide,
  },
  props:["slides"],
  setup () {
    const modules = [Pagination];

    return {
      modules,
    }
  }
}
</script>

<style>
.avisosSwiper .swiper-pagination-bullet{
  background: transparent;
  border: 2px solid #6eb7ec;
  width: 13px;
  height: 13px;
  margin: 5px 7px;
  --swiper-pagination-bullet-inactive-opacity: 1;
  --swiper-pagination-bullet-horizontal-gap: 7px;
}

.swiper-pagination{
    --swiper-pagination-bottom: 0px;
  }

@media (max-width: 767px) {
  .swiper{
    padding-bottom: 50px;
  }

  .swiper-pagination{
    --swiper-pagination-bottom: 40px;
  }
}

.avisosSwiper .swiper-pagination-bullet-active,
.avisosSwiper .swiper-pagination-bullet:hover{
  background: #6eb7ec;
  cursor: pointer;
}
</style>

<style lang="scss" scoped>
.avisosSwiper .swiper-pagination-bullet{
  background: transparent;
  border: 2px solid #6eb7ec;
  width: 13px;
  height: 13px;
  margin: 5px 7px;
}

.swiper-pagination-bullet-active,
.swiper-pagination-bullet:hover{
  background: #6eb7ec;
  cursor: pointer;
}

.grid-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  margin-bottom: 20px;
}

@media (max-width: 676px) {
  .grid-container {
    grid-template-columns: repeat(1, 1fr);
    margin-bottom: 0;
  }
}

.grid-item{
  padding-right:.9375rem;
  padding-left: .9375rem
}
 
.tipo{
  color: #1380a0c4;
  display: flex;
  font-family: "Montserrat Semibold";
  font-size: 15px;
  align-items: center;
  margin-bottom: 5px;
}

img{
  width: auto;
  height: 30px;
  display: inline-block;
  margin-right: 5px;
}

.title{
  font-family: "Montserrat SemiBold";
  color: #2F2E2E;
  margin-bottom: 50px;
  display: block;
}

.tipo i{
  font-size: 23px;
  margin-right: 7px;
}

@media (max-width: 676px) {
  .title {
    margin-bottom: 25px;
    font-size: 14px;
  }
  
}
</style>